/**
 * For now, this file is simply setting up global exports of ALL classes.
 * We need to do this because of the dependencies on global scope that we have across the app.
 * Someday, this may not be needed anymore.
 */

import { AppRouter } from './router/AppRouter';
import AppConfiguration from './utils/Configuration/AppConfiguration';
import AppClientDbMapping from './utils/Configuration/AppClientDbMapping';
import { CustomPathHolder } from './router/CustomPathHolder';
import { Accessibility } from './utils/Accessibility/Accessibility';
import DeviceManager from './ui/objects/DeviceManager';
import { GlobalNotification } from './components/pubnub/GlobalNotification';
import { GlobalErrorHandler } from './errors/GlobalErrorHandler';
import { GlobalHelperFunctions } from './utils/GlobalHelperFunctions';
import { LanguageConfigurations } from './utils/Configuration/LanguageConfigurations';
import { NumberConfigurations } from './utils/Configuration/NumberConfigurations';
import { FontAwesomeConfigurations } from './utils/Configuration/FontAwesomeConfiguration';
import { EmoijPicker } from './ui/objects/EmojiPicker';
import { EmojiButton } from '@joeattardi/emoji-button';
import AmazonIVSPlayer from './ui/objects/AmazonIVSPlayer';
import { Contrast } from './utils/Accessibility/Contrast';
import ReactComponent from './ui/ReactComponent';
import LiveChat from './ui/objects/livechat/LiveChat';
import SocialSquareRotatorSlide from './ui/objects/rotators/SocialSquareRotatorSlide';
import SocialLikeContainer from './ui/objects/SocialLikeContainer';
import SocialCommentContainer from './ui/objects/SocialCommentContainer';
import AwsApi from './utils/AwsFrontend/AwsApi';
import FileUploadHelper from './ui/objects/junofileupload/_fileUploadHelper';
import JUNOFileUpload from './ui/objects/junofileupload/index';
import PartnerRotatorSlide from './ui/objects/rotators/PartnerRotatorSlide';
import StreamVideoPlayer from './ui/opentok/StreamVideoPlayer';
import ArchivePanel from './ui/objects/panels/ArchivePanel';
import LeaderboardPanel from './ui/objects/panels/LeaderboardPanel';
import { ForceTagDecision } from './ui/objects/ForceTagDecision';
import VNextLearningPanel from './ui/objects/panels/VNextLearningPanel';
import VNextCertificatesPanel from './ui/objects/panels/VNextCertificatesPanel';
import VNextAnalyticsPanel from './ui/objects/panels/VNextAnalyticsPanel';
import ProfileCoursesPanel from './ui/objects/panels/ProfileCoursesPanel';
import Hammer from 'hammerjs';
import NotificationPanel from './ui/objects/panels/NotificationPanel/index';
import NotificationPreferencesPanel from './ui/objects/panels/NotificationPreferencesPanel/index';
import PushNotificationHandler from './utils/PushNotificationHandler';
import NotificationsContentEditorPanel from './ui/objects/panels/fet/NotificationsContentEditorPanel';
import ProfileCePanel from './ui/objects/panels/ProfileCoursesPanel/ProfileCePanel';
import VNextGroupsPanel from './ui/objects/panels/VNextGroupsPanel';
import VNextAdminPanel from './ui/objects/panels/VNextAdminPanel';

// @ts-ignore
window.AppRouter = AppRouter;
// @ts-ignore
window.AppConfiguration = AppConfiguration;
// @ts-ignore
window.AppClientDbMapping = AppClientDbMapping;
// @ts-ignore
window.CustomPathHolder = CustomPathHolder;
// @ts-ignore
window.Accessibility = Accessibility;
// @ts-ignore
window.DeviceManager = DeviceManager;
// @ts-ignore
window.Contrast = Contrast;
// @ts-ignore
window.GlobalNotification = GlobalNotification;
// @ts-ignore
window.GlobalErrorHandler = GlobalErrorHandler;
// @ts-ignore
window.GlobalHelperFunctions = GlobalHelperFunctions;
// @ts-ignore
window.LanguageConfigurations = LanguageConfigurations;
// @ts-ignore
window.NumberConfigurations = NumberConfigurations;
// @ts-ignore
window.FontAwesomeConfigurations = FontAwesomeConfigurations;
// @ts-ignore
window.EmojiPicker = EmoijPicker;
// @ts-ignore
window.EmojiButton = EmojiButton;
// @ts-ignore
window.AmazonIVSPlayer = AmazonIVSPlayer;
// @ts-ignore
window.ReactComponent = ReactComponent;
// @ts-ignore
window.SocialSquareRotatorSlide = SocialSquareRotatorSlide;
// @ts-ignore
window.SocialLikeContainer = SocialLikeContainer;
// @ts-ignore
window.SocialCommentContainer = SocialCommentContainer;
// @ts-ignore
window.AwsApi = AwsApi;
// @ts-ignore
window.FileUploadHelper = FileUploadHelper;
// @ts-ignore
window.JUNOFileUpload = JUNOFileUpload;
// @ts-ignore
window.PartnerRotatorSlide = PartnerRotatorSlide;
// @ts-ignore
window.Hammer = Hammer;
// @ts-ignore
window.LiveChat = LiveChat;
// @ts-ignore
window.StreamVideoPlayer = StreamVideoPlayer;
// @ts-ignore
window.ArchivePanel = ArchivePanel;
// @ts-ignore
window.ForceTagDecision = ForceTagDecision;
// @ts-ignore
window.NotificationPanel = NotificationPanel;
// @ts-ignore
window.NotificationPreferencesPanel = NotificationPreferencesPanel;
// @ts-ignore
window.PushNotificationHandler = PushNotificationHandler;
// @ts-ignore
window.LeaderboardPanel = LeaderboardPanel;
// @ts-ignore
window.VNextLearningPanel = VNextLearningPanel;
// @ts-ignore
window.VNextCertificatesPanel = VNextCertificatesPanel;
// @ts-ignore
window.ProfileCoursesPanel = ProfileCoursesPanel;
// @ts-ignore
window.VNextAnalyticsPanel = VNextAnalyticsPanel;
//@ts-ignore
window.NotificationsContentEditorPanel = NotificationsContentEditorPanel;
//@ts-ignore
window.ProfileCePanel = ProfileCePanel;
//@ts-ignore
window.VNextGroupsPanel = VNextGroupsPanel;
//@ts-ignore
window.VNextAdminPanel = VNextAdminPanel;
